import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "../../pages/FlowChat/Home.css";

const NavPrompt = ({
  chatPrompt,
  chatId,
  flowId,
  subscriptionId,
  onOpenChat,
}) => {
  const [url, setUrl] = useState("");
  const chatPromptCharacters = chatPrompt.split("");
  const history = useHistory();

  useEffect(() => {
    setUrl(
      `${process.env.PUBLIC_URL}/chat?flow_id=${flowId}&subscription_id=${subscriptionId}&chat_id=${chatId}`
    );
  }, []);

  return (
    <div
      className="navPrompt"
      onClick={() => {
        history.push(url);
        setTimeout(() => {
          onOpenChat();
        }, 600);
      }}
      style={{ textAlign: "left" }}
    >
      <svg
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        fill="#650098"
        stroke="#650098"
        width={16}
        height={16}
      >
        <path
          fill="#650098"
          fillRule="evenodd"
          d="M15 3.25A2.25 2.25 0 0 0 12.75 1h-9.5A2.25 2.25 0 0 0 1 3.25v11a.75.75 0 0 0 1.26.55l2.801-2.6a.75.75 0 0 1 .51-.2h7.179A2.25 2.25 0 0 0 15 9.75v-6.5zm-2.25-.75a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-.75.75H5.572a2.25 2.25 0 0 0-1.531.6L2.5 12.53V3.25a.75.75 0 0 1 .75-.75h9.5z"
          clipRule="evenodd"
        />
      </svg>
      <p>
        {chatPromptCharacters.map((char, idx) => (
          <span key={idx} style={{ animationDelay: `${idx * 0.1}s` }}>
            {char}
          </span>
        ))}
      </p>
    </div>
  );
};

export default NavPrompt;